import React, { useState } from 'react';
import { Modal, Form, Input, Select, Checkbox, notification, Upload, Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import imageCompression from 'browser-image-compression';
import api from '../api/axios';

const { TextArea } = Input;
const { Option } = Select;

const ReportModal = ({ isOpen, onClose, profileId }) => {
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [includeScreenshot, setIncludeScreenshot] = useState(false);
    const [fileList, setFileList] = useState([]);

    const handleSubmit = async (values) => {
        setIsLoading(true);
        try {
            const formData = new FormData();
            formData.append('profile_id', profileId);
            formData.append('report_type', values.reportType);
            formData.append('description', values.description);

            if (includeScreenshot && fileList.length > 0) {
                const screenshot = await imageCompression(fileList[0].originFileObj, {
                    maxSizeMB: 0.5,
                    maxWidthOrHeight: 1280,
                    useWebWorker: true,
                });
                formData.append('screenshot', screenshot);
            }

            const response = await api.post('/profiles/report', formData);

            if (response.status === 201 && response.data.status === 'success') {
                notification.success({
                    message: 'Report Submitted Successfully',
                    description: 'Your report has been submitted successfully!',
                });
                onClose();
                form.resetFields();
                setIncludeScreenshot(false);
                setFileList([]);
            } else {
                notification.error({
                    message: 'Report Submission Failed',
                    description: response.data.message || 'Something went wrong. Please try again.',
                });
            }
        } catch (error) {
            notification.error({
                message: 'Report Submission Failed',
                description: error.response?.data?.message || 'An error occurred while submitting the report. Please try again.',
            });
        } finally {
            setIsLoading(false);
        }
    };

    const handleScreenshotChange = ({ fileList }) => {
        setFileList(fileList);
    };

    return (
        <Modal
            title="Report Profile/Photo"
            open={isOpen}
            onCancel={onClose}
            footer={null}
            width={600}
            centered
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
                style={{ marginTop: '20px' }}
            >
                <Form.Item
                    name="reportType"
                    label="Report Type"
                    rules={[{ required: true, message: 'Please select a report type' }]}
                >
                    <Select placeholder="Select report type">
                        <Option value="profile">Profile</Option>
                        <Option value="photo">Photo</Option>
                        <Option value="behavior">Behavior</Option>
                        <Option value="other">Other</Option>
                    </Select>
                </Form.Item>

                <Form.Item
                    name="description"
                    label="Description"
                    rules={[{ required: true, message: 'Please provide a description' }]}
                >
                    <TextArea
                        rows={4}
                        placeholder="Please describe the issue in detail"
                    />
                </Form.Item>

                <Form.Item>
                    <Checkbox
                        checked={includeScreenshot}
                        onChange={(e) => setIncludeScreenshot(e.target.checked)}
                    >
                        Include Screenshot
                    </Checkbox>
                </Form.Item>

                {includeScreenshot && (
                    <Form.Item
                        name="screenshot"
                        rules={[{ required: true, message: 'Please upload a screenshot' }]}
                    >
                        <Upload
                            accept="image/*"
                            beforeUpload={() => false}
                            onChange={handleScreenshotChange}
                            fileList={fileList}
                            maxCount={1}
                        >
                            <Button icon={<UploadOutlined />}>Upload Screenshot</Button>
                        </Upload>
                    </Form.Item>
                )}

                <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
                    <Button type="primary" htmlType="submit" loading={isLoading}>
                        Submit Report
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default ReportModal; 